import React from 'react';

export default class TestResults extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            testResults: {}
        }
    }
    componentDidMount()
    {
        this.getTestResults();
    }
    getTestResults()
    {
        this.props.api.send({
            controller: "Test",
            action: "GetTestResult",
            method: "post",
            body: JSON.stringify({courseID: this.props.courseID, testID: this.props.testID}),
            success: (result) => {
                if (result.success) {
                    this.setState({ testResults: result.grade })
                    this.finishTest();
                }
            },
            error: (err) => {
                this.setState({ loaded: true });
            }
        });
    }
    finishTest() {
        this.props.api.send({
            controller: "Test",
            action: "FinishTest",
            method: "post",
            body: JSON.stringify({ courseID: this.props.courseID, testID: this.props.testID }),
            success: (result) => {
                this.setState({ loaded: true });
            },
            error: (err) => {
                this.setState({ loaded: true })
            }
        })
    }
    render()
    {
        const percent = Math.round((parseInt(this.state.testResults.answersCorrect, 10) / parseInt(this.state.testResults.totalAnswers, 10)) * 100);
        return (
            <div>
                <div className="lmscoursearea">
                    {this.state.loaded ? (
                        <div>
                            <h3>
                                You correctly answered <strong>{this.state.testResults.answersCorrect}</strong> out of <strong>{this.state.testResults.totalAnswers}</strong> questions.
                            </h3>
                            <h3>
                                You scored {percent}%.
                            </h3>
                            {this.props.pretest ? (
                                <h3>
                                    Your score shows room for improvement.  Please press "Continue" to review the course materials.
                                </h3>
                            ) : (
                                <h3>
                                    {percent >= 75 ? (
                                        <div>
                                            <h3>
                                                Congratulations, you have passed this course!  Contact <a href="mailto:csem@csem.com"><u>CSEM</u></a> to order a certificate of completion.
                                            </h3>
                                            <h3>
                                                You may also call the number: 888-701-2736
                                            </h3>
                                        </div>
                                    ) : (
                                        <h3>
                                            Unfortunately, your score is not high enough to pass this course and earn a certification.  Please try again.
                                        </h3>
                                    )}
                                </h3>
                            )}
                        </div>
                    ) : (
                        <div className="lmscenter">
                            <img src="/images/spinner.svg" alt="Loading..."  className="spinnerbg" />
                        </div>
                    )}
                </div>
                <div className="lmstestfooter">
                    {this.props.pretest ? (
                        <input className="lmsbutton lmsquestionbutton" type="button" value="Continue" onClick={this.props.phaseFinished} />
                    ) : (
                        <div>
                            <input className="lmsbutton lmsquestionbutton" type="button" value="Close" onClick={this.props.phaseFinished} />
                        </div>
                    )}
                    
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/course/testresults.js